import type { RichTextFontSchemaType } from '@vedalib/editor/lib/brand'
import React from 'react'

import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont } from 'services/Branding/components'
import type { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import type { ElementFontCss, ElementFontValue } from 'services/Branding/types'
import { t } from 'services/Translation'

interface IBrandRichTextTypographyProps {
  setActiveFont: (font: keyof typeof FONT_FIELDS) => void
  edited?: Record<keyof typeof FONT_FIELDS, boolean>
  styles: ElementFontCss<RichTextFontSchemaType>
  values: ElementFontValue<RichTextFontSchemaType>
}

const BrandRichTextTypography: React.FC<IBrandRichTextTypographyProps> = ({
  setActiveFont,
  styles,
  values,
  edited,
}) => {
  return (
    <>
      <Typography size={KitSize.L}>{t('page.brand.fonts.richText')}</Typography>
      <Typography styleType='hint' wordBreak='normal'>
        {t('page.brand.fonts.richTextHint')}
      </Typography>

      <BrandButtonFont
        edited={edited?.base}
        font='base'
        onClick={setActiveFont}
        styles={styles.base}
        values={values.base}
      >
        {t('entity.font.base')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.h1}
        font='h1'
        onClick={setActiveFont}
        styles={styles.h1}
        values={values.h1}
      >
        {t('entity.font.h1')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.h2}
        font='h2'
        onClick={setActiveFont}
        styles={styles.h2}
        values={values.h2}
      >
        {t('entity.font.h2')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.h3}
        font='h3'
        onClick={setActiveFont}
        styles={styles.h3}
        values={values.h3}
      >
        {t('entity.font.h3')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.h4}
        font='h4'
        onClick={setActiveFont}
        styles={styles.h4}
        values={values.h4}
      >
        {t('entity.font.h4')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.caption}
        font='caption'
        onClick={setActiveFont}
        styles={styles.caption}
        values={values.caption}
      >
        {t('entity.font.caption')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.list}
        font='list'
        onClick={setActiveFont}
        styles={styles.list}
        values={values.list}
      >
        {t('entity.font.list')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.quote}
        font='quote'
        onClick={setActiveFont}
        styles={styles.quote}
        values={values.quote}
      >
        {t('entity.font.quote')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited?.link}
        font='link'
        onClick={setActiveFont}
        styles={styles.link}
        values={values.link}
      >
        {t('entity.font.link')}
      </BrandButtonFont>
    </>
  )
}

export default React.memo(BrandRichTextTypography) as typeof BrandRichTextTypography
